module.exports = __webpack_public_path__ + "img/video_xflj_01.d92ef1a2.jpg";